import { Props_SnippetAccordion } from "./Accordion.props";
import React, { useState } from "react";
import { motion } from "framer-motion";

export const SnippetAccordion = (props: Props_SnippetAccordion) => {
  const { accordionTitle, repeatable_accordionRow } = props;
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleAccordion = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="snippet-accordion">
      <div className="snippet-accordion__container">
        {accordionTitle?.heading.value && (
          <h2 className="snippet-accordion__title">{accordionTitle.heading.value}</h2>
        )}

        <div className="snippet-accordion__row-container">
          {repeatable_accordionRow.map((accordionRow, index) => {
            const isOpen = openIndex === index;

            return (
              <div key={index} className={`snippet-accordion__row ${isOpen ? 'snippet-accordion__row--open' : ''}`}>
                <button className="snippet-accordion__row-title" onClick={() => toggleAccordion(index)}>
                  {accordionRow?.title?.value}
                </button>
                <motion.div
                  className="snippet-accordion__content-container"
                  initial={false}
                  animate={{ height: isOpen ? "auto" : 0, opacity: isOpen ? 1 : 0 }}
                  transition={{ duration: 0.3, ease: "easeInOut" }}
                >
                  {accordionRow?.text?.value && <p className="snippet-accordion__text">{accordionRow.text.value}</p>}
                  {accordionRow?.linkhref?.value && accordionRow?.linktext?.value && (
                    <a href={accordionRow.linkhref.value} className="snippet-accordion__link attrax-button">
                      {accordionRow.linktext.value}
                    </a>
                  )}
                </motion.div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
